import dividerPrimaryGradientUrl from "../assets/img/border/divider-primary-gradient.svg"
import { Container, Grid, TextField } from "@mui/material"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import React from "react"
import { useAppDispatch, useAppSelector } from "../store"
import { setUserLoading } from "../store/userReducer"
import { connectHandler } from "../utils/connectHandler"
import LoadingButton from "@mui/lab/LoadingButton"
import CtaButton from "../components/button/CtaButton"
import Stack from "@mui/material/Stack"
import useMediaQuery from "@mui/material/useMediaQuery"
import { SEO } from "../components/SEO"
import { PATHS } from "../constants/paths"
import Button from "@mui/material/Button"

// Компонент для отображения обратного отсчета
const CountdownRenderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return <span>Started!</span>
  } else {
    return (
      <span style={{ color: "#00ff88", fontWeight: "bold" }}>
        {String(days)}d {String(hours).padStart(2, "0")}h{" "}
        {String(minutes).padStart(2, "0")}m {String(seconds).padStart(2, "0")}s
      </span>
    )
  }
}

export const FCD = () => {
  const dispatch = useAppDispatch()
  const { user, loading } = useAppSelector((state) => state.user)
  const getWallet = () => {
    dispatch(setUserLoading(true))
    connectHandler(dispatch)
  }

  const isDownSm = useMediaQuery("(max-width: 600px)")

  // Дата начала 2026 года
  const goalCountdownDate = new Date("2026-01-01T00:00:00")

  return (
    <Box>
      <SEO
        title="Zombie TD | FCD - Fair Community Distribution"
        description="Join the Zombie TD Fair Community Distribution (FCD). Buy ZTD tokens at a fair price during 3 transparent rounds."
        ogTitle="Zombie TD | FCD Token Sale"
        ogDescription="Get ZTD tokens at the fairest price with no whitelist, no KYC. Join the FCD and be part of the community launch!"
        ogUrl={PATHS.FCD.PATH}
      />
      <Box className="content">
        <Box className="content-head" mb={4}>
          <Container fixed>
            <Box mb={4}>
              <Typography variant={"h1"} mb={2}>
                FCD Information
              </Typography>
              <Typography
                variant="subtitle1"
                mb={2}
                pl={2}
                sx={{
                  borderLeft: "1px solid transparent",
                  borderImage: `url(${dividerPrimaryGradientUrl}) 1 stretch`,
                }}
              >
                FCD(Fair Community Distribution) is a transparent,
                community-driven model for token distribution. Instead of a fixed
                price, the final token price is determined by the total amount
                of USDT contributed during each round.
                <br />
                <br />
                FCD includes 3 rounds, each lasting 24 hours. During a round,
                you can contribute any amount of USDT (minimum 10 USDT, BEP-20).
                After the round ends, the total USDT raised is divided by the
                number of tokens allocated — setting one fair price for all
                participants. Tokens are automatically distributed based on each
                participant’s contribution.
              </Typography>
            </Box>

            <Box
              sx={{
                border: "1px solid transparent",
                borderRadius: 2,
                borderImage: `url(${dividerPrimaryGradientUrl}) 1 stretch`,
              }}
              py={3}
              mb={4}
            >
              <Typography variant="h4" textAlign="center">
                FCD Round 1 Starts in: TBA
                {/*<Countdown*/}
                {/*  date={goalCountdownDate}*/}
                {/*  renderer={CountdownRenderer}*/}
                {/*/>*/}
              </Typography>
            </Box>
          </Container>
        </Box>

        <Box className="content-body">
          <Container fixed>
            <Grid container spacing={3}>
              <Grid item md={12}>
                {/* Обертка для двух блоков в ряд */}
                <Box sx={{ display: isDownSm ? "block" : "flex", gap: 3 }}>
                  {/* Блок 1: Participate Now */}
                  <Box
                    sx={{
                      flex: 1,
                      borderRadius: 2,
                      p: 3,
                      background: "rgba(255, 255, 255, .05)",
                      borderLeft: "1px solid transparent",
                      borderImage: `url(${dividerPrimaryGradientUrl}) 1 stretch`,
                    }}
                  >
                    <Typography variant="h4" mb={2} textAlign="center">
                      Participate Now
                    </Typography>
                    <Box my={1} sx={{ pl: { xs: 2, sm: 3 } }}>
                      <Typography gutterBottom>
                        <Box className="primary">
                          1. <b>Connect your Web3 wallet</b>
                        </Box>
                        <Box className="primary">
                          2. <b>Switch to BNB Smart Chain (BEP-20)</b> network
                        </Box>
                        <Box className="primary">
                          3. <b>Enter the amount you wish to contribute</b>{" "}
                          (minimum <b>10 USDT</b>) and confirm the transaction
                        </Box>

                        <TextField
                          id="amount-tokens"
                          // value={form.amountTokens}
                          // onChange={(e) =>
                          //   setForm((prevState) => ({
                          //     ...prevState,
                          //     amountTokens: e.target.value,
                          //   }))
                          // }
                          label="Enter a min of 10 USDT"
                          min={10}
                          variant="outlined"
                          size="small"
                          fullWidth
                          type="number"
                          disabled={!user.address}
                          shrink
                          inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9]*",
                            min: 1,
                          }}
                          sx={{
                            mt: 2,
                          }}
                        />

                        {user.address ? (
                          <Button
                            color="primary"
                            variant="contained"
                            // onClick={onWithdraw}
                            disabled={true}
                            fullWidth
                            sx={{
                              width: "100%",
                              mt: 2,
                            }}
                          >
                            Participate Now
                          </Button>
                        ) : (
                          <>
                            {loading ? (
                              <LoadingButton
                                loading
                                variant="contained"
                                sx={{
                                  width: "100%",
                                  mt: 2,
                                }}
                              >
                                Submit
                              </LoadingButton>
                            ) : (
                              <CtaButton
                                variant="contained"
                                onClick={getWallet}
                                disabled={loading}
                                size="small"
                                sx={{
                                  width: "100%",
                                  mt: 2,
                                }}
                              >
                                Connect Wallet
                              </CtaButton>
                            )}
                          </>
                        )}

                        <Typography
                          fontStyle={"italic"}
                          fontSize={{ xs: 13, sm: 15 }}
                          mt={2}
                        >
                          No need to claim - your tokens will be automatically
                          added to your balance after the round ends.
                        </Typography>
                      </Typography>
                    </Box>
                  </Box>

                  {/* Блок 2: Live FCD Stats */}
                  <Box
                    sx={{
                      flex: 1,
                      borderRadius: 2,
                      p: 3,
                      background: "rgba(255, 255, 255, .05)",
                      borderLeft: "1px solid transparent",
                      borderImage: `url(${dividerPrimaryGradientUrl}) 1 stretch`,
                    }}
                    mt={{ xs: 4, sm: 0 }}
                  >
                    <Typography variant="h4" mb={2} textAlign="center">
                      Live FCD Stats
                    </Typography>

                    <Stack spacing={1} sx={{ pl: { xs: 2, sm: 3 } }}>
                      <Typography gutterBottom>
                        <span className="primary">
                          Track the current FCD round 1 in real time:
                        </span>
                      </Typography>

                      <ul className="customList">
                        <li>
                          <span className="primary">Participants: </span>-
                        </li>
                        <li>
                          <span className="primary">Total USDT Raised: </span>-
                        </li>
                        <li>
                          <span className="primary">1 ZTD Price (live): </span>-
                        </li>
                        <li>
                          <span className="primary">Your Contribution: </span>-
                        </li>
                        <li>
                          <span className="primary">
                            Estimated ZTD You'll Receive:{" "}
                          </span>
                          - ZTD
                        </li>
                        {/*<li>*/}
                        {/*  <span className="primary">Your Rank: </span>#*/}
                        {/*  /!*You are currently in the Top-35 contributors in FCD Round 1*!/*/}
                        {/*</li>*/}
                      </ul>

                      <Typography
                        fontStyle={"italic"}
                        fontSize={{ xs: 13, sm: 15 }}
                        mt={2}
                      >
                        Final values lock when the round ends.
                      </Typography>
                    </Stack>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  )
}
